/* eslint-disable no-param-reassign */
import { EXIT_TIME, EXIT_EASING, STANDARD_TIME, STANDARD_EASING } from 'constants/animations';

// adapted from https://css-tricks.com/using-css-transitions-auto-dimensions/
// animates height to 0 by getting explicit height from dom
export const useHeightAnimation = (
  element,
  {
    heightAnimationTime = STANDARD_TIME,
    heightAnimationEasing = STANDARD_EASING,
    opacityAnimationTime = EXIT_TIME,
    opacityAnimationEasing = EXIT_EASING,
  } = {},
) => {
  // element will disappear before the gap is filled because exit is shorter than standard
  const elementTransition = `height ${heightAnimationTime}s ${heightAnimationEasing}, opacity ${opacityAnimationTime}s ${opacityAnimationEasing}`;

  const collapse = (height = 0, opacity = false) => {
    if (!element) return;
    // temporarily disable all css transitions
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
      // sets the height to the height of the element's inner content, regardless of its actual size
      element.style.height = `${element.scrollHeight}px`;
      element.style.opacity = 1;

      element.style.transition = elementTransition;

      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(() => {
        element.style.height = `${height}px`;
        if (opacity) {
          element.style.opacity = 0;
        }
      });
    });
  };
  const expand = (height = 0, opacity = false) => {
    if (!element) return;
    // temporarily disable all css transitions
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
      if (opacity) {
        element.style.opacity = 0;
      }
      element.style.transition = elementTransition;

      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(() => {
        element.style.height = `${element.scrollHeight}px`;
        element.style.opacity = 1;
      });
    });
  };

  // adjusts between two different frames
  const adjust = () => {
    if (!element) return;
    // temporarily disable all css transitions
    element.style.transition = '';

    requestAnimationFrame(() => {
      element.style.height = 'auto';
      element.style.transition = elementTransition;
    });
  };

  return { collapse, expand, adjust };
};
